import React, { ReactElement } from "react";
import { IHospital } from "~/types/hospital";

import s from "~/components/common/AdditionalHospitals/AdditionalHospitals.module.scss";
import styles from "~/App.module.scss";

import HospitalCard from "~/components/cards/hospitals/HospitalCard";
import { useNavigate } from "react-router-dom";
import ROUTES from "~/utils/routes";
import { logEvent } from "~/utils/amplitude";

interface Props {
  hospitals: IHospital[];
  onClick: (id: number) => void;
}

const AdditionalHospitals: React.FC<Props> = ({ onClick, ...props }) => {
  const hospitals = [...props.hospitals];
  const maxToShow = 4;
  const navigate = useNavigate();

  const showMore = () => {
    logEvent("Д/ Нажал кнопку Показать еще");
    navigate(ROUTES.HOSPITALS.PATHNAME, { replace: true });
  };

  const hospitalCards: ReactElement<typeof HospitalCard>[] = hospitals
    .splice(0, maxToShow)
    .map((hospital) => {
      return (
        <HospitalCard
          key={hospital.idHospital}
          hospitalData={hospital}
          onClick={() => onClick(hospital.idHospital)}
        />
      );
    });

  return (
    <>
      {true ? ( //hospitalCards.length
        <>
          <div className={styles.appointmentHeadingWrap}>
            <h2 className="headline-2">
              Другие больницы доступные для онлайн записи:
            </h2>
          </div>
          <div className={s.containerCards}>{hospitalCards}</div>
          <div className={s.showMore}>
            <button className="button" onClick={showMore}>
              Показать еще
            </button>
          </div>
        </>
      ) : null}
    </>
  );
};

export default AdditionalHospitals;
